import * as PIXI from "pixi.js";
import TopSwitcher from "../../../../../../../src/entities/UI/TopSwitcher/TopSwitcher";
import { TopSwitcherProps } from "../../../../../../../src/types/Interface";
import { EnumEventBus, eventBus } from "../../EventBus";
import { TestTopSwicherButtonStyles, TSwtButEventBusNames } from "../../../types/Config";
import { Direction } from "../../../types/Enum";
import { disabledfilter } from "../../../../../../../src/filters";

export default class PointAnswerConFactory {
  static genDirectionButton(con?: PIXI.Container): TopSwitcher {
    const style = TestTopSwicherButtonStyles.directionButton;
    const TopSwitcherProps: TopSwitcherProps = {
      topButtonsProps: [
        {
          label: Direction.clockwise,
          onHandleDownFunc: () => eventBus.emit(EnumEventBus.setDirection, Direction.clockwise)
        },
        {
          label: Direction.antiClockwise,
          onHandleDownFunc: () => eventBus.emit(EnumEventBus.setDirection, Direction.antiClockwise)
        }
      ],
      eventBusName: TSwtButEventBusNames.dirBut
    }
    const button = new TopSwitcher(TopSwitcherProps, con, style.opts);
    button.setCoord(style.coord);
    return button;
  }
  static genRotationButton(con?: PIXI.Container): TopSwitcher {
    const style = TestTopSwicherButtonStyles.rotationButton
    const TopSwitcherProps: TopSwitcherProps = {
      topButtonsProps: [
        {
          label: "90",
          onHandleDownFunc: () => eventBus.emit(EnumEventBus.setRotation, 90)
        },
        {
          label: "180",
          onHandleDownFunc: () => eventBus.emit(EnumEventBus.setRotation, 180)
        },
        {
          label: "270",
          onHandleDownFunc: () => eventBus.emit(EnumEventBus.setRotation, 270)
        }
      ],
      eventBusName: TSwtButEventBusNames.rotBut
    }
    const button = new TopSwitcher(TopSwitcherProps, con, style.opts);
    button.setCoord(style.coord);
    return button;
  }
  static setAnswerButtons(AnswerCon: PIXI.Container, isDisabled: boolean) {
    AnswerCon.children.forEach(b => {
      b.filters = isDisabled ? [disabledfilter] : [];
      b.eventMode = isDisabled ? "none" : "static";
    })
  }
}